export function isPriceRecordValidForComparison(a, b) {
    // Ensure both records have a valid tripStateId
    if (a.tripStateId == null || b.tripStateId == null || a.tripStateId === undefined || b.tripStateId === undefined) {
        return false;
    }
    // Check if tripStateId and estabId match between the two records
    if (a.tripStateId !== b.tripStateId || a.estabId !== b.estabId) {
        return false;
    }
    // Verify that both price values are valid numbers
    if (typeof a.price !== 'number' || typeof b.price !== 'number') {
        return false;
    }
    // If all conditions are met, the price records are valid for comparison
    return true;
}
